import React, { useEffect } from 'react';

import { inject, observer } from 'mobx-react';
import { compose } from 'utils/compose';

import useIsWindowFocused from 'hooks/useIsWindowFocused';

// no-dd-sa:javascript-code-style/parameter-name
const withTabActive = (Component) =>
  compose(
    inject('store'),
    observer,
  )((props) => {
    const { deliveryStore } = props?.store;
    const { countdownTimer } = deliveryStore;
    const isTabActive = useIsWindowFocused();

    useEffect(() => {
      if (isTabActive) {
        deliveryStore.recalculateTimer();
      } else {
        clearInterval(countdownTimer);
      }
    }, [isTabActive]);
    return <Component {...props} />;
  });

export default withTabActive;
